import React from "react";
import clsx from "clsx";
import { Form } from "react-bootstrap";

const useErrorMessage = ({ meta }) => {
	const isTouched = meta.touched || meta.message?.touched;

	const isInvalid =
		meta.error?.isRequired !== undefined
			? isTouched && meta.error?.isRequired
			: meta.error && isTouched;

	const isTypeOfErrorString = typeof meta.error === "string";

	const ErrorTitle = () => {
		if (isTypeOfErrorString) return meta.error;
		else return meta.error?.message;
	};
	const ErrorMessage: React.FC = () =>
		meta.error ? (
			<Form.Control.Feedback
				className={clsx(
					"d-block",
					isTypeOfErrorString
						? "text-danger"
						: !isInvalid && "text-warning",
				)}
				type={isTouched && isInvalid ? "invalid" : undefined}
			>
				{ErrorTitle()}
			</Form.Control.Feedback>
		) : null;

	return { ErrorMessage, isInvalid };
};

export default useErrorMessage;

